<template>
  <div>
    <app-header color="primary"></app-header>
    <main class="register">
      <div class="container-fluid">
        <b-form class="register-form" @submit="onSubmitEditForm">

          <b-form-input
            v-model="registerForm.first_name"
            class="form-control-custom"
            required
            placeholder="ชื่อจริง">
          </b-form-input>

          <b-form-input
            v-model="registerForm.last_name"
            class="form-control-custom"
            required
            placeholder="นามสกุล">
          </b-form-input>

          <b-form-input
            maxlength="13"
            :class="{ 'spacing-text': this.isFullCitizen() }"
            @input="changeCitizenID"
            v-model="registerForm.citizen_id"
            class="form-control-custom"
            required
            placeholder="หมายเลขบัตรประชาชน">
          </b-form-input>

          <div class="gender-label">วันเกิด:</div>
          <datepicker :inputClass="innerInputDate" :language="th" class="input-date" v-model="registerForm.dob"
                      name="birthday" style="width: 100%"></datepicker>

          <!--          <b-form-input-->
          <!--                -->
          <!--                  type="date"-->
          <!--                  class="form-control-custom"-->
          <!--                  required-->
          <!--                  placeholder="วัน/เดือน/ปีเกิด">-->
          <!--          </b-form-input>-->

          <div class="gender-field">
            <label class="gender-label">เพศ :</label>
            <div class="row flex-grow-1">
              <div class="col text-center">
                <button
                  :class="{ 'btn-custom-primary': registerForm.gender == 'm',
                              'btn-custom-primary-outline': registerForm.gender != 'm' }"
                  class="btn  btn-round btn-block"
                  type="button" @click="genderSelect('m')">
                  ชาย
                </button>
              </div>
              <div class="col text-center">
                <button
                  :class="{ 'btn-custom-primary': registerForm.gender == 'f',
                         'btn-custom-primary-outline': registerForm.gender != 'f' }"
                  class="btn btn-round btn-block"
                  type="button" @click="genderSelect('f')">
                  หญิง
                </button>
              </div>
            </div>
          </div>

          <!--          <b-form-input-->
          <!--                  v-model="registerForm.phone"-->
          <!--                  class="form-control-custom"-->
          <!--                  required-->
          <!--                  placeholder="หมายเลขโทรศัพท์">-->
          <!--          </b-form-input>-->

          <label class="gender-label">ที่อยู่ :</label>
          <b-form-select
            v-model="registerForm.province_code"
            class="form-control-custom"
            @change="changeProvince"
            :options="provinceList">
          </b-form-select>
          <b-form-select
            v-model="registerForm.amphoe_code"
            class="form-control-custom"
            @change="changeDistrict"
            :options="districtList">
          </b-form-select>
          <b-form-select
            v-model="registerForm.district_code"
            class="form-control-custom"
            @change="changeSubdistrict"
            :options="subDistrictList">
          </b-form-select>

          <label class="gender-label">ประวัติ :</label>
          <b-form-input
            v-model="registerForm.educational_institution"
            class="form-control-custom"
            required
            placeholder="ชื่อสถานศึกษาสูงสุด">
          </b-form-input>

          <b-form-select
            v-model="registerForm.education_level"
            class="form-control-custom"
            :options="educationLevelList">
          </b-form-select>

          <b-form-input
            v-model="registerForm.working_at"
            class="form-control-custom"
            required
            placeholder="ชื่อสถานประกอบการ">
          </b-form-input>
        </b-form>
      </div>

      <hr>

      <div class="container-fluid">
        <div class="text-center">
          <button
            type="button"
            class="btn btn-custom-primary btn-round shadow-bottom"
            @click="onSubmitEditForm">
            ยืนยันการแก้ไข
          </button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  import AppHeader from '../components/Header.component'
  import Services from '../services'
  import Datepicker from 'vuejs-datepicker'
  import {th} from 'vuejs-datepicker/dist/locale'
  import {mapGetters, mapActions} from 'vuex'
  import { alertPrefix, educationLevelList } from '../utils/Constants'

  export default {
    name: 'editprofile',
    components: {
      AppHeader,
      Datepicker
    },
    data () {
      return {
        th: th,
        innerInputDate: 'innerInputDate',
        dateType: 'text',
        spaceStyle: 'normal',
        provinceList: [
          {
            text: 'จังหวัด',
            value: 'null'
          }
        ],
        districtList: [
          {
            text: 'อำเภอ',
            value: 'null'
          }
        ],
        subDistrictList: [
          {
            text: 'ตำบล',
            value: 'null'
          }
        ],
        registerForm: {
          profile_picture: null,
          first_name: '',
          last_name: '',
          citizen_id: '',
          dob: '',
          gender: 'male',
          phone: '',
          email: '',
          province_code: null,
          amphoe_code: null,
          district_code: null,
          educational_institution: '',
          education_level: null,
          working_at: '',
          password: '',
          password_confirmation: ''
        },
        firstLoad: true,
        educationLevelList: [
          {
            text: 'ระดับการศึกษา',
            value: null
          },
          ...educationLevelList.map(educationLevel => ({
            text: educationLevel,
            value: educationLevel
          }))
        ],
        alertPrefix: alertPrefix
      }
    },
    computed: {
      ...mapGetters({token: 'User/getToken', user: 'User/getUser'})
    },
    beforeMount () {
      this.registerForm = this.user
      try {
        this.registerForm.educational_institution = this.user.profile_educations[this.user.profile_educations.length - 1].educational_institution
      } catch (e) {
        this.registerForm.educational_institution = ''
      }
      try {
        this.registerForm.education_level = this.user.profile_educations[this.user.profile_educations.length - 1].education_level
      } catch (e) {
        this.registerForm.education_level = ''
      }
      try {
        this.registerForm.working_at = this.user.profile_experiences[this.user.profile_experiences.length - 1].working_at
      } catch (e) {
        this.registerForm.working_at = ''
      }
      this.startPage()
    },
    mounted () {
      console.log(this.registerForm)
    },
    methods: {
      isFullCitizen () {
        try {
          if (this.registerForm.citizen_id.length === 13) {
            return true
          }
        } catch (e) {
          return false
        }
        return false
      },
      startPage () {
        this.firstLoad = true
        if (this.registerForm.province_code == null) {
          this.registerForm.province = 10
        }
        Services.provinceLocations.getProvince().then(data => {
          var provinceList = []
          data.forEach(function (province) {
            provinceList.push({
              text: province.province,
              value: province.province_code
            })
          })
          this.provinceList = provinceList
          this.changeProvince(this.registerForm.province_code)
        })
      },
      onSubmitEditForm () {
        if (!this.checkCitizenID(this.registerForm.citizen_id)) {
          alert(alertPrefix + 'รหัสบัตรประชาชนผิด')
          return false
        }

        // eslint-disable-next-line no-undef
        NProgress.start()
        var self = this
        Services.auth.editProfile(this.registerForm, this.token).then(function (response) {
          var status = response.status
          if (status === 'success') {
            alert(alertPrefix + 'แก้ไขสำเร็จ')
            self.$router.push('/profile')
          } else {
            // var message = response.result {"code":200,"status":"Validate Fails.","result":["The email has already been taken.","The citizen id has already been taken."]}
            var message = response.result.join()
            alert(alertPrefix + message)
          }
          // eslint-disable-next-line no-undef
          NProgress.done()
        })
      },
      changeCitizenID (value) {
        this.registerForm.citizen_id = value
      },
      checkCitizenID (id) {
        let sum = 0
        if (id.length !== 13) {
          return false
        }
        for (let i = 0; i < 12; i++) {
          sum += parseFloat(id.charAt(i)) * (13 - i)
        }
        return (11 - sum % 11) % 10 === parseFloat(id.charAt(12))
      },
      genderSelect (gender) {
        this.registerForm.gender = gender
      },
      changeProvince (value) {
        if (this.firstLoad === false) {
          this.registerForm.province_code = value
        }
        Services.provinceLocations.getDistrict(value).then(data => {
          var amphoeList = []
          data.forEach(function (province) {
            amphoeList.push({
              text: province.amphoe,
              value: province.amphoe_code
            })
          })
          this.districtList = amphoeList
          if (this.firstLoad === false) {
            this.registerForm.amphoe_code = this.districtList[0].value
          }
          this.changeDistrict(this.registerForm.amphoe_code)
        })
      },
      changeDistrict (value) {
        if (this.firstLoad === false) {
          this.registerForm.amphoe_code = value
        }
        Services.provinceLocations.getSubDistrict(this.registerForm.province_code, this.registerForm.amphoe_code).then(data => {
          var subdistrictList = []
          data.forEach(function (province) {
            subdistrictList.push({
              text: province.district,
              value: province.district_code
            })
          })
          this.subDistrictList = subdistrictList

          if (this.firstLoad === false) {
            this.registerForm.district_code = data[0].district_code
          }
        })
      },
      changeSubdistrict (value) {
        if (this.firstLoad === false) {
          this.registerForm.district_code = value
        } else {
          this.firstLoad = true
        }
      },
      changeTypeDate () {
        this.dateType = 'date'
      }
    },
    ...mapActions({setToken: 'User/setToken', setUser: 'User/setUser'})
  }
</script>

<style lang="scss" scoped>
  @import "../styles/styles";

  .input-date {
    border: 1px solid #ced4da;
    border-radius: 9999px;
    padding: 0 30px;
    margin-bottom: 10px;
    width: 100%;
    height: 35px;
  }

  .innerInputDate {
    border: none;
    width: 100%;
    height: 32px;
  }

  main.register {
    padding: $header-height 0 30px;
    margin-top: 10px;
    .upload-image-wrapper {
      @extend .d-flex;
      margin-bottom: 10px;
      .upload-image {
        @extend .cursor-pointer;
        margin: auto;
        background-image: url('../assets/img/profile/upload-image-circle.png');
        height: 83px;
        width: 83px;
        display: flex;
        position: relative;
        .camera {
          margin: auto;
        }
      }
    }
    .gender-field {
      @extend .d-flex;
      margin-bottom: 10px;
      .gender-label {
        margin-bottom: 0;
        margin-right: 30px;
        line-height: 40px;
      }
    }
    hr {
      margin: 40px 0 20px;
    }

    .spacing-text {
      letter-spacing: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/EditProfile.page.vue